const React = require('react');
const shallowCompare = require('react-addons-shallow-compare');

const helper = require('../../helper/dish-helper');
const getCoupon = helper.getUrlParam('getCoupon');
// const couponBtn = require('../../asset/images/coupon-btn.svg');
// const shopId = helper.getUrlParam('shopId');
// const type = helper.getUrlParam('type');
require('./dish-coupon.scss');

import FormattedMessage from '@/intl/formatted-message';
import { formatMessage } from '../../intl/helper';
import globalMessages from './../../intl/messages/global';

module.exports = React.createClass({
  displayName:'DishCoupon',
  propTypes:{
    // reducer
    shopInfo: React.PropTypes.object,
    firstStatus: React.PropTypes.number,

    // action
    getMarketCoupon: React.PropTypes.func,
    closeFixedCoupon: React.PropTypes.func,
    showCouponAnimation: React.PropTypes.func,
    showAlreadyGotCoupon: React.PropTypes.func,
  },
  getDefaultProps() {
    return {
      shopInfo: {},
    };
  },
  getInitialState() {
    return {
      getCouponStatus:false, // 是否已领券
    };
  },
  componentDidMount() {
    this.shouldGetCoupon = true;
  },
  componentWillReceiveProps(nextProps) {
    const nextCoupon = nextProps.shopInfo.couponSuccessInfo;
    const thisCoupon = this.props.shopInfo.couponSuccessInfo;
    const isOldMarketing = nextProps.shopInfo.isOldMarketing;

    if (isOldMarketing && nextCoupon && nextCoupon !== thisCoupon) { // 老逻辑取券成功
      this.setState({ getCouponStatus:true });
    }

    // 触发领券
    const marketCoupon = nextProps.shopInfo.marketCoupon; // 老逻辑
    const couponList = nextProps.shopInfo.couponList; // 新逻辑
    const couponSuccess = nextProps.shopInfo.couponSuccess; // 新逻辑
    const { getMarketCoupon } = this.props;

    // 老逻辑自动领券
    if (getCoupon === 'true' && isOldMarketing && marketCoupon.coupId && !nextCoupon
      && marketCoupon.flag && this.shouldGetCoupon
    ) {
      this.shouldGetCoupon = false;
      getMarketCoupon(marketCoupon.coupId);
    }

    // 新逻辑自动领券
    if (getCoupon === 'true' && !isOldMarketing && couponList && couponList.length > 0 && !couponSuccess
      && nextProps.shopInfo.flag && this.shouldGetCoupon
    ) {
      this.shouldGetCoupon = false;
      getMarketCoupon(couponList[0].coupId);
    }
  },
  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  },
  getCouponSuccess() {
    const { shopInfo, getMarketCoupon, closeFixedCoupon } = this.props;
    if (!shopInfo.couponSuccessInfo) {
      if (!shopInfo.marketCoupon.flag) {
        return false;
      }
      setTimeout(() => {
        if (shopInfo.isOldMarketing) { // 老逻辑
          getMarketCoupon(shopInfo.marketCoupon.coupId, closeFixedCoupon);
        } else { // 新逻辑
          getMarketCoupon(shopInfo.ruleId, closeFixedCoupon);
        }
      }, 600);
    }

    return true;
  },
  setCouponValue(marketCoupon) {
    // 领券成功
    if (marketCoupon.coupType === 1 || marketCoupon.coupType === 4) {
      return (
        <div className="price">{marketCoupon.value}</div>
      );
    } else if (marketCoupon.coupType === 2) {
      return (
        <div>{marketCoupon.value}<small><FormattedMessage {...globalMessages.discount} /></small></div>
      );
    }
    return false;
  },
  handleGetCoupons(e, coupId, couldFetch, checkGetCoupon) {
    e.stopPropagation();
    e.preventDefault();
    const { couponType, getMarketCoupon, showAlreadyGotCoupon } = this.props;
    const { isOldMarketing, couponList } = this.props.shopInfo;
    if (!couldFetch) {
      if (checkGetCoupon && showAlreadyGotCoupon) { // 在不能领券 + 查看的情况下
        showAlreadyGotCoupon(checkGetCoupon);
      }
      return;
    }

    if (couponType === 'dishMenu') {
      if (isOldMarketing) {
        getMarketCoupon(coupId);
      } else {
        getMarketCoupon(couponList[0].coupId);
      }
    }
  },
  render() {
    const { getCouponStatus } = this.state;
    const { shopInfo, firstStatus } = this.props;
    const marketCoupon = shopInfo.marketCoupon || {};
    // const couponValue = this.setCouponValue(marketCoupon);

    const { isOldMarketing, flag, type: newType } = shopInfo;
    let couldFetch = true;
    let couponWord = formatMessage(globalMessages.getCoupon);
    let checkGetCoupon = false;
    if (isOldMarketing) { // 老逻辑
      if (!shopInfo.marketCoupon.flag && shopInfo.marketCoupon.type === 1) {
        couponWord = formatMessage(globalMessages.haveFinished);
        couldFetch = false;
      } else if (getCouponStatus || !shopInfo.marketCoupon.flag && shopInfo.marketCoupon.type === 2) {
        couponWord = formatMessage(globalMessages.viewPackage);
        couldFetch = false;
        checkGetCoupon = true;
      }
    } else { // 新逻辑
      // const alreadySendCouponNew = localStorage.alreadySendCouponNew || '';
      if (!flag && newType === 1) {
        couponWord = formatMessage(globalMessages.haveFinished);
        couldFetch = false;
      } else if (shopInfo.couponSuccess || !flag && newType === 2) {
        couponWord = formatMessage(globalMessages.viewPackage);
        couldFetch = false;
        checkGetCoupon = true;
      }
    }

    return (
      <div className="dish-coupon clearfix">
        <div className="dish-coupon-inner">
          {firstStatus === 1 ? <i className="coupon-icon coupon-icon--top"></i> : ''}
          {firstStatus === 1 ? <i className="coupon-icon coupon-icon--bottom"></i> : ''}
          <div className="dish-coupon-content">
            <div className="clearfix" style={{ width: '100%', textAlign: 'left' }}>
              <FormattedMessage {...globalMessages.storePackage} />
            </div>
          </div>
          <div className="dish-coupon-status">
            <span
              className="dish-coupon-status__btn"
              onTouchTap={(e) => this.handleGetCoupons(e, marketCoupon.coupId, couldFetch, checkGetCoupon)}
            >{couponWord}</span>
          </div>
        </div>
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./src/component/dish-menu/dish-coupon.jsx